// Este codigo fue generado por Github Copilot Chat
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Collaborator } from '../../helpers/collaborator.model';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'app-avatar-collapsible',
  standalone: true,
  imports: [CommonModule, AvatarComponent],
  templateUrl: './sura-avatar-collapsible.component.html',
  styleUrls: ['./sura-avatar-collapsible.component.scss']
})
export class SuraAvatarCollapsibleComponent {
  @Input() collaborators: Collaborator[] = [];
  expandedIndex: number | null = null;

  // Si hay solo un colaborador, se muestra expandido por defecto
  get alwaysExpanded(): boolean {
    return this.collaborators.length === 1;
  }

  getInitials(fullName: string): string {
    if (!fullName) return '';
    return fullName
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('')
      .substring(0, 2);
  }

  toggleExpand(index: number | null): void {
    this.expandedIndex = index;
  }
}
// Este codigo fue generado por Github Copilot Chat
